
// import React from 'react'
// import ReactDOM from "react-dom/client";

// import { App } from "./App";
// import { ViewDocument, PartnerReport } from './components';

// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(
//   <React.StrictMode>
//   <ViewDocument />
//   </React.StrictMode>
// );

//https://react-pdf-viewer.dev/docs/basic-usage/
import packageJSON from '../../../package.json';
export const pdfjsVersion = () => {
  return packageJSON.dependencies["pdfjs-dist"];
};


export {
  TestAnt,
  ViewDocument,
  EventsReport,
  PartnerReport,
  NYSReport,
  STEMIOlympiadReport,
  ActivityIndicator,
  AddressControl,
  CheckboxSwitchery,
  ContactField,
  FileCard,
  GenericChart,
  GenericGeoMap,
  InvalidPage,
  Offline,
  ProgressControl,
  ProgressPercControl,
  ReportButtons,
  ReportTemplate,
  RichTextEditor,
  SearchControl,
  openNotification,
  FormItemList,
  ParagraphHeader,
  CitizenScienceReport,
  EventsGeographicReport,
  FileGeneratorProgress,
  DownloadDataAsExcel,
  VolunteerScientistReport,
  ListingEvents,
  AddEditEvent,
  EventCard,
  ContributeModal,
  DataCapturerCard,
  AddDataCapturerToEvent,
  Organisations,
  SelectedOrganizations,
  OrganizationList,
  OrganizationForm,
  CaptureAttendee,
  IndividualCapturing,
  GroupCapturing,
  ScienceFacilitatorsCapturing,
  LocationListForm,
  GeoSearch,
  reportTypeEnum,
  contribEnum,
  docsEnum,
  genEnum,
  defaultSettingEnum,
  localityEnum,
  paginationEnum,
  eventCreationModeEnum,
  progressIndicatorEnum,
  fieldValidity,
  booleanEnum,
  citizenScienceStatusEnum,
  citizenScienceStatusContribEnum,
  csParticipRoleEnum,
  CustomDateRangePicker,
  PrivacyStatment,
  RegisterUser,
  UserProfile,
  UserChangePassword,
  DataCard,
  GenericCardList,
  GenericSearchableList,
  PageHeaderControl,
  LocationAccessControl,
  EventContainer,
  EventsHelp,
  OfflineDataViewer,
  confirmAction,
} from "./components";
export { ReactQueryProvider} from "./providers";
export {
  Messages,
  Notify,
  usersService,
  dbService,
  eventsGuideService,
  lookupService,
  logService
} from "./services";
export { HeaderProvider, useHeader} from "./contexts";
export {
  useOfflineMutationQueue,
  useOfflineQueueControl,
  syncAllOfflineQueues,
  getOfflineQueueRegistryState,
  getOfflineQueueTelemetrySnapshot,
} from "./hooks/useOfflineMutationQueue";
export { useTelemetry } from "./hooks/useTelemetry";
export { useTelemetryBackgroundSync } from "./hooks/useTelemetryBackgroundSync";
export { usePWA } from "./hooks/usePWA";
export { useResponsiveSettings } from "./hooks/useResponsiveSettings";
export { initTelemetry, getTelemetry, TELEMETRY_EVENT_TYPES } from "./telemetry";
export { getRuntimeEnvironment } from "./utils/runtimeEnvironment";
export {
  getApplicationVersion,
  getClientId,
  trackPwaMetric,
  handlePwaVersion,
  setupPwaTelemetry,
} from "./utils/pwaVersionManager";

//! Development Test: Mocking offline queue utilities for testing
//! This should help come up with different test scenarios for offline functionality
export {
  injectMockOfflineQueues,
  clearMockOfflineQueues,
  getTotalMockQueueCount,
  setupMockOfflineRegistry,
} from "./hooks/useOfflineMutationQueue.dev";

export { util } from "./utils/functions/custom";
export * as AppSecurity from "./security"
export * as constants from "./constants"
